import { DashboardComponentPropsBase } from "components/pages/dashboard/components/interfaces";
import { T } from "services/lang/LanguageService";
import { ReportOptions } from "models/component-print-models";
import { IComponentTheme } from "../product-template-table/utils/interfaces";
import { DatasetLoadingConf } from "../charts/interfaces";

export interface LineChartLegendEditorProps {
  config: LineChartLegendProps;
  onConfigChange: (newConfig: LineChartLegendProps) => void;
}

export interface LineChartLegendProps extends DashboardComponentPropsBase<ReportOptions>, IComponentTheme {
  loadConf: DatasetLoadingConf;
  dataType: DataType;
  datasets?: string[];
}

export enum DataType {
  MONTHS = "MONTHS",
  YEARS = "YEARS",
  DATASETS = "DATASETS",
}

export const dataTypeOptions = [
  { label: T("time.months"), value: DataType.MONTHS },
  { label: T("time.years"), value: DataType.YEARS },
  { label: T("word.datasets"), value: DataType.DATASETS },
];
